import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
    minicartAutoclose: {
      type: Boolean,
      attribute: 'autoclose',
    },
    minicartAutocloseDuration: {
      type: Number,
      attribute: 'autoclose-duration',
    },
  }

  constructor() {
    super()

    this.loading = false
    this.minicartAutocloseDuration = 0

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')

    if (window.wasteNot) {
      this.submitButton.addEventListener(
        'click',
        this.validateWasteNotProduct.bind(this)
      )
    }

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    const formData = JSON.parse(serializeForm(this.form))

    const recipientNameElement = this.querySelector(
      '[name="properties[Recipient name]"]'
    )
    const recipientName = recipientNameElement ? recipientNameElement.value : ''

    const recipientEmailElement = this.querySelector(
      '[name="properties[Recipient email]"]'
    )
    const recipientEmail = recipientEmailElement
      ? recipientEmailElement.value
      : ''

    const recipientMessageElement = this.querySelector(
      '[name="properties[Message]"]'
    )
    const recipientMessage = recipientMessageElement
      ? recipientMessageElement.value
      : ''

    const recipientDateElement = this.querySelector(
      '[name="properties[Send on]"]'
    )
    const recipientDate = recipientDateElement ? recipientDateElement.value : ''

    formData.properties = {
      ...(formData.properties || {}),
      ...(recipientMessage && { Message: recipientMessage }),
      ...(recipientName && { 'Recipient name': recipientName }),
      ...(recipientEmail && { 'Recipient email': recipientEmail }),
      ...(recipientEmail && { __shopify_send_gift_card_to_recipient: true }),
      ...(recipientDate && { 'Send on': recipientDate }),
    }

    const response = await addToCart(formData)

    if (response.errors) {
      alert(response.errors)
      this.submitButton.removeAttribute('disabled')
      this.submitButton.classList.remove('loading')
      return
    }

    reRenderShopifySections(response)

    if (this.showMiniCartAfterSubmission) {
      utils.toggle(document.body, ['mini-cart-is-active'])
    }

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          response: response,
        },
      })
    )

    const header = document.querySelector('hh-header')
    if (header) {
      header.toggleCart()

      if (this.minicartAutoclose && this.minicartAutocloseDuration > 0) {
        setTimeout(() => {
          if (document.body.classList.contains('mini-cart-is-active')) {
            header.toggleCart()
          }
        }, `${this.minicartAutocloseDuration * 1000}`)
      }
    }

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')

    setTimeout(() => {
      this.loading = false
    }, 100)
  }

  async validateWasteNotProduct(event) {
    if (Shopify.country !== 'US' || !window.wasteNot) return
    event.preventDefault()
    try {
      const response = await fetch(`/cart.js`)
      const cartData = await response.json()
      const cartItems = cartData.items || []
      const wasteNotProductId = window.wasteNot.product
      const wasteNotProduct = cartItems.findIndex(
        (product) => product.id === wasteNotProductId
      )

      if (
        wasteNotProduct >= 0 ||
        (event.target.dataset.startingVariant == wasteNotProductId &&
          cartItems.length > 0)
      ) {
        document.addEventListener(
          'submitForm',
          this.clearCartAndSubmitForm.bind(this)
        )
        document.body.setAttribute(
          'modal',
          JSON.stringify({ id: 'waste-not-modal' })
        )
      } else {
        this.form.dispatchEvent(new Event('submit'))
      }
    } catch (error) {
      console.error('Error fetching cart data:', error)
    }
  }

  async clearCartAndSubmitForm() {
    if (!this.loading) {
      await utils.clearCart()
      document.body.setAttribute('modal', JSON.stringify({ id: 'close' }))

      this.loading = true
      this.form.dispatchEvent(new Event('submit'))
      document.removeEventListener(
        'submitForm',
        this.clearCartAndSubmitForm.bind(this)
      )
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
